import styled from 'styled-components';
import { IThemeProvider } from '../../../styles/theme';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const Text = styled.span<IThemeProvider>`
  font-weight: 400;
  font-size: 12px;
  ${({ theme }) => `
    color: ${theme.colors.neutral.primary[60]};
  `}
`;
